import styled from 'styled-components';

export const IngredientInformationsModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
